module.exports = __webpack_public_path__ + "img/logo.bc93d0f3.png";